module.exports = __webpack_public_path__ + "assets/dashboard.163c0ed5.svg";